import { z } from 'zod';
import { requiredString } from '../helpers';
export const Strada_Get_Claim_Data_1_ConfigValidator = z.object({
    callId: requiredString('Call ID path is required')
});
//# sourceMappingURL=strada-get-claim-data-1.js.map